import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../../web/ReactQueryProvider';
import { timeEntryKeys } from './keys';
import { ITimeEntryPage, ITimeEntryReview, ITimeEntryReviewQueueScope } from './types';

export function useTimeEntryReviewQueueQuery({
	enabled = true,
	managerUserId,
	userId,
}: { enabled?: boolean } & ITimeEntryReviewQueueScope = {}) {
	const userSession = useUserSession();
	const params = new URLSearchParams();
	if (managerUserId) {
		params.set('managerUserId', managerUserId);
	}
	if (userId) {
		params.set('userId', userId);
	}
	const query = params.toString();
	return useQuery({
		queryKey: timeEntryKeys.reviewQueue({ managerUserId, userId }),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ITimeEntryPage<ITimeEntryReview>>(
				query ? `TimeEntry/reviewQueue?${query}` : 'TimeEntry/reviewQueue',
				'GET'
			),
		enabled,
		staleTime: 60_000,
		meta: {
			errorLogging: { action: 'useTimeEntryReviewQueueQuery', category: 'TimeEntry' },
		} satisfies LevStandardQueryMeta,
	});
}
